module.exports = __webpack_public_path__ + "static/media/intermediate.48d10b74.svg";